const dimension = {
  dimension: "Dimension",
  dimensions: "Dimensions",
  add_dimension: "Add Dimension",
  edit_dimension: "Edit Dimension",
  name: "Name",
  value: "Value",
  code: "Code",
  description: "Description",
  actions: "Actions",
  edit: "Edit",
  delete: "Delete",
  view_dimension_values: "View Dimension Values",
  dimension_values: "Dimension Values",
  add_dimension_value: "Add Dimension Value",
  edit_dimension_value: "Edit Dimension Value",
  name_required: "Name is required",
  value_required: "Value is required",
  code_required: "Code is required",
  dimension_created_successfully: "Dimension created successfully",
  dimension_updated_successfully: "Dimension updated successfully",
  dimension_deleted_successfully: "Dimension deleted successfully",
  dimension_value_created_successfully: "Dimension value created successfully",
  dimension_value_updated_successfully: "Dimension value updated successfully",
  dimension_value_deleted_successfully: "Dimension value deleted successfully",
  delete_dimension_title: "Delete Dimension",
  delete_dimension_description:
    "Are you sure you want to delete this dimension?",
  delete_dimension_value_title: "Delete Dimension Value",
  delete_dimension_value_description:
    "Are you sure you want to delete this dimension value?",
  no_dimensions_found: "No dimensions found",
  no_dimension_values_found: "No dimension values found",
  cancel: "Cancel",
  save: "Save",
  add: "Add",
  update: "Update",
  something_went_wrong: "Something went wrong",
  add_filter: "Add Filter",
  filter_dimension_values: "Filter Dimension Values",
  clear_all: "Clear All",
  apply: "Apply",
  values: "Values",
  dimension_has_active_values:
    "The dimension has active values and cannot be deleted.",
  dimension_id_required: "Dimension ID is required.",
  dimension_is_system_reserved:
    "This dimension is system-reserved and cannot be modified or deleted.",
  dimension_name_already_exists:
    "A dimension with the same name already exists.",
  dimension_name_required: "Dimension name is required.",
  dimension_not_found: "Dimension not found.",
  dimension_not_found_or_not_allowed:
    "Dimension not found or you are not allowed to add values to it.",
  dimension_value_name_required: "Dimension value name is required.",
  dimension_value_not_found: "Dimension value not found.",
  dimension_value_required: "Dimension value is required.",
  dimension_value_value_required: "Dimension value is required.",
  not_allowed_to_delete_dimension:
    "You are not allowed to delete this dimension.",
  not_allowed_to_delete_dimension_value:
    "You are not allowed to delete this dimension value.",
  not_allowed_to_update_dimension:
    "You are not allowed to update this dimension.",
  not_allowed_to_update_dimension_value:
    "You are not allowed to update this dimension value.",
  organization_not_found: "Organization not found for the current user.",
  dimension_name_cannot_be_updated_for_system_reserved:
    "The dimension name cannot be updated because it is system-reserved.",
  dimension_name_invalid_format:
    "Dimension name must contain only English letters, with no spaces or special characters.",
};

export default dimension;
